import ActionTypes from './ActionTypes';

const getTemplates = payload => {
    return {
        type: ActionTypes.TEMPLATES,
        payload,
    };
};

const getMyTemplates = payload => {
    return {
        type: ActionTypes.MY_TEMPLATES,
        payload,
    };
};

const getGuestGroup = payload => {
    return {
        type: ActionTypes.GET_GUEST_GROUP,
        payload,
    };
};

const deleteGuestGroup = payload => {
    return {
        type: ActionTypes.DELETE_GUEST_GROUP,
        payload,
    };
};

const getGuestList = payload => {
    return {
        type: ActionTypes.GUEST_LIST,
        payload,
    };
};

const getMenu = payload => {
    return {
        type: ActionTypes.GET_MENU,
        payload,
    };
};

const getSeating = payload => {
    return {
        type: ActionTypes.GET_SEATING,
        payload,
    };
};

const getAttendee = payload => {
    return {
        type: ActionTypes.GET_ATTENDEE,
        payload,
    };
};

const getPending = payload => {
    return {
        type: ActionTypes.GET_PENDING,
        payload,
    };
};

const getAttendeeDetails = payload => {
    return {
        type: ActionTypes.ATTENDEE_DETAIL,
        payload,
    };
};

const setRSVP = payload => {
    return {
        type: ActionTypes.SET_RSVP,
        payload,
    };
};

const getTidbits = payload => {
    return {
        type: ActionTypes.GET_TIDBITS,
        payload,
    };
};

const getQna = payload => {
    return {
        type: ActionTypes.GET_QNA,
        payload,
    };
};

const ClearRSVP = () => {
    return {
        type: ActionTypes.CLEAR_RSVP,
    };
};



export {
    getTemplates,
    getMyTemplates,
    getGuestGroup,
    deleteGuestGroup,
    getGuestList,
    getMenu,
    getSeating,
    getAttendee,
    getPending,
    getAttendeeDetails,
    setRSVP,
    getTidbits,
    getQna,
    ClearRSVP
};
